'use client';

import { createContext, useContext, useState } from 'react';

import type { Contact } from '@/src/utils/types';

interface UserContextType {
  user: Contact | null;
  setUser: (user: Contact | null) => void;
}

export const UserContext = createContext<UserContextType | null>(null);

interface UserProviderProps {
  user: Contact | null;
  children: React.ReactNode;
}

export const UserProvider = ({ user: initialUser, children }: UserProviderProps) => {
  const [user, setUser] = useState<Contact | null>(initialUser);

  return <UserContext.Provider value={{ user, setUser }}>{children}</UserContext.Provider>;
};

export const useUser = () => {
  const context = useContext(UserContext);

  if (!context) {
    throw new Error('useUser() must be used within a UserProvider.');
  }

  return context.user;
};

export const useSetUser = () => {
  const context = useContext(UserContext);

  if (!context) {
    throw new Error('useSetUser() must be used within a UserProvider.');
  }

  return context.setUser;
};
